import React from 'react';
import {useTranslation} from 'react-i18next';
import {useNavigate} from 'react-router-dom';
import {PATHS} from 'routes/constants';
import {useSummary} from 'context/summary';
import {useBuildNavigationItems, useGuestGroup, usePath, usePaymentsCart} from 'hooks';
import {BookingPAymentRequiredText, CompletedGuestText} from './styled';
import {useLayoutMode} from 'hooks/useLayoutMode';
import {Button, cn} from '@chekin/guestapp-ui-kit';

type Props = {
  showIncompletePaymentsMessage?: boolean;
  hideTitle?: boolean;
};
function CompletedGuestsStep({hideTitle, showIncompletePaymentsMessage}: Props) {
  const {areAllGuestsRegistered} = useGuestGroup();
  const {arePaymentsAvailable} = useSummary();
  const {t} = useTranslation();
  const {paymentsCart} = usePaymentsCart({refetchOnMount: false});
  const navigate = useNavigate();
  const {getFullPath} = usePath();
  const {getPaymentPath} = useBuildNavigationItems();
  const layoutMode = useLayoutMode();

  const goToPayments = React.useCallback(() => {
    if (arePaymentsAvailable && paymentsCart?.pay_now_payments) {
      navigate(getFullPath(getPaymentPath()));
      return;
    }
    navigate(getFullPath(PATHS.home));
  }, [
    arePaymentsAvailable,
    getFullPath,
    navigate,
    paymentsCart?.pay_now_payments,
    getPaymentPath,
  ]);

  const showPaymentsButton = areAllGuestsRegistered && showIncompletePaymentsMessage;

  return (
    <>
      {!hideTitle && (
        <CompletedGuestText
          className={cn(
            'chekin-next-step-modal__chekin-all-registered-te',
            'kiosko:text-kiosko-l kiosko:mb-12',
          )}
        >
          {t('all_guest_have_been_registered')}
        </CompletedGuestText>
      )}
      {layoutMode === 'default' && (
        <>
          {showIncompletePaymentsMessage && (
            <BookingPAymentRequiredText className="chekin-next-step-modal__chekin-booking-payment-required-text">
              {t('booking_payments_are_required_to_complete_complete_checkin')}
            </BookingPAymentRequiredText>
          )}

          {showPaymentsButton && (
            <Button className="w-full" onClick={goToPayments}>
              {t('go_to_booking_payments')}
            </Button>
          )}
        </>
      )}
    </>
  );
}

export {CompletedGuestsStep};
